<div class="p-20 fx-row fx-wrap align-items-center justify-content-center text-center">
    <div class="fx-flex-100 align-items-center justify-content-center text-center">
        <span class="title mb-10 text-center">{{(plan ? 'CREATE_PLAN_DIALOG.TITLE_UPDATE' : 'CREATE_PLAN_DIALOG.TITLE')
            | translate}}</span>
    </div>
    <span class="text mt-20">{{(plan ? 'CREATE_PLAN_DIALOG.INSTRUCTIONS_UPDATE' : 'CREATE_PLAN_DIALOG.INSTRUCTIONS') |
        translate:plan}}</span>
    <div class="fx-flex-100 fx-row fx-wrap align-items-center justify-content-center mt-20">
        <app-input [placeholder]="('PLAN.LABEL' | translate) + '...'" type="text" class="mb-10 fx-flex-100"
            [(value)]="planToCreate.label" [error]="errors['label']" [bottomWrapper]="true"></app-input>
        <app-select initial="none" label="{{'PLAN.TYPE' | translate}}" [options]="types" [multiple]="false"
            [emitOnInit]="false" (change)="onPlanTypeChange($event)" [value]="planToCreate.type" [labelOutside]="false"
            class="fx-flex-100" [error]="errors['type']" [bottomWrapper]="true"></app-select>
    </div>
    <div class="fx-flex-100 fx-row align-items-start justify-content-center mt-20">
        <div class="mb-10 fx-flex-50 pr-8">
            <app-input [placeholder]="('PLAN.MAX_VOLUME' | translate) + '...'" type="number"
                [(value)]="planToCreate.maxVolume" [error]="errors['maxVolume']" [bottomWrapper]="true"></app-input>
        </div>
        <div class="mb-10 fx-flex-50 pl-8">
            <app-input [placeholder]="('PLAN.MAX_TRADEMARKS' | translate) + '...'" type="number"
                [(value)]="planToCreate.maxTrademarks" [error]="errors['maxTrademarks']"
                [bottomWrapper]="true"></app-input>
        </div>
    </div>
    <div class="fx-flex-100 fx-row align-items-start justify-content-center mt-20">
        <div class="mb-10 fx-flex-50 pr-8">
            <app-input [placeholder]="('PLAN.MAX_CASES' | translate) + '...'" type="number"
                [(value)]="planToCreate.maxCases" [error]="errors['maxCases']" [bottomWrapper]="true"></app-input>
        </div>
        <div class="mb-10 fx-flex-50 pl-8">
            <app-input [placeholder]="('PLAN.MAX_CRAWLER_URL' | translate) + '...'" type="number"
                [(value)]="planToCreate.maxCrawlerUrl" [bottomWrapper]="true"></app-input>
        </div>
    </div>
    <div class="fx-flex-100 fx-row align-items-start justify-content-center mt-20">
        <div class="mb-10 fx-flex-50 pr-8">
            <app-input [placeholder]="('PLAN.ANNUAL_PRICE' | translate) + '...'" type="number"
                [(value)]="planToCreate.annualPrice" [error]="errors['annualPrice']" [bottomWrapper]="true"
                prefix="euro"></app-input>
        </div>
        <div class="mb-10 fx-flex-50 pl-8"></div>
    </div>
    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-row align-items-center justify-content-center fx-flex-100">
        <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
        <button class="main-button fx-flex ml-10" (click)="plan ? onUpdate() : onCreate()"
            [class.disabled]="_hasErrors()" [disabled]="_hasErrors()">{{(plan ? 'ACTIONS.UPDATE':'ACTIONS.CREATE')
            | translate}}</button>
    </div>
</div>